import moment from "moment";

export function getAmountOfCheckListRows(pluginTimestamp: number | null, plugoutTimestamp: number | null): number {
	if (!pluginTimestamp) {
		return 0;
	}

	const today = moment().startOf("day");
	const startDay = moment(pluginTimestamp).startOf("day");

	if (plugoutTimestamp) {
		const endDay = moment(plugoutTimestamp).startOf("day");
		const daysDiff = endDay.diff(startDay, "days");
		return Math.max(1, daysDiff + 1);
	}

	if (startDay.isBefore(today)) {
		const daysDiff = today.diff(startDay, "days") + 1;
		return Math.min(daysDiff, 25);
	}

	return 1;
}

export const createCheckList = ({ checks, pluginTimestamp, plugoutTimestamp }: {
	checks: {
		id: number | null;
		timestamp: number | null;
		temperature: number | null;
	}[];
	pluginTimestamp: number | null;
	plugoutTimestamp: number | null;
}) => {

	if (!pluginTimestamp) {
		return [];
	}

	const rows = getAmountOfCheckListRows(pluginTimestamp, plugoutTimestamp);
	const startDate = moment(pluginTimestamp).startOf("day");

	const formattedChecks = checks
		.filter(c => c.timestamp !== null || c.temperature !== null)
		.map(item => ({
			...item,
			dateStr: item.timestamp ? moment(item.timestamp).format("DD-MM-YYYY") : null,
		}))
		.sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0));

	return Array.from({ length: rows }).map((_, index) => {
		const currentDateMoment = moment(startDate).add(index, "days");
		const currentDateStr = currentDateMoment.format("DD-MM-YYYY");
		const dayChecks = formattedChecks.filter(item => item.dateStr === currentDateStr);

		return {
			date: currentDateStr,
			list: Array.from({ length: 3 }).map((_, columnIndex) => {
				const check = dayChecks[columnIndex];
				return {
					id: check?.id ?? null,
					timestamp: check?.timestamp ?? null,
					temperature: check?.temperature ?? null,
				};
			}),
		};
	});
};
